import { render, staticRenderFns } from "./TriggerModal.vue?vue&type=template&id=8a56fc62"
import script from "./TriggerModal.vue?vue&type=script&lang=ts"
export * from "./TriggerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports